import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-help-download',
    templateUrl: './help-download.component.html',
    styleUrls: ['./help-download.component.css'],
    standalone: false
})
export class HelpDownloadComponent implements OnInit {

  // website name and link type
  @Input() website: string = "";
  @Input() linkType: string = "";

  // images
  @Input() getImgs: string[] = [];
  @Output() showImg: EventEmitter<string> = new EventEmitter<string>();

  constructor() {

  }

  ngOnInit(): void {

  }

  // show selected image on screen
  showImage(url: string): void {
    this.showImg.emit(url);
  }

}
